import {GetRefundCities} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundGetCities} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundCities = (): GetRefundCities =>
	new RemoteRefundGetCities(
		makeBFFApiUrl(RefundFlowEndPoints.cities),
		makeAuthorizeHttpClientDecorator(),
	);
